import React from 'react';
import { styled, keyframes } from 'styled-components';
import { Button } from './Button';
import { Device } from '../../../../play-core/styles/Device';
import { Shadows } from '../../../../play-core/styles/Shadows';
import { zIndex } from '../../../../play-core/styles/z-index';
import { Marble } from '../Marble/Marble';
import { PlayContainer } from '../PlayContainer/PlayContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const FloatingButton = ({
  ...rest
}) => /*#__PURE__*/_jsx(Layout, {
  children: /*#__PURE__*/_jsx(PlayContainer, {
    children: /*#__PURE__*/_jsx(MarbleLayout, {
      children: /*#__PURE__*/_jsx(StyledMarble, {
        children: /*#__PURE__*/_jsx(StyledButton, {
          ...rest
        })
      })
    })
  })
});
const Layout = styled.div.withConfig({
  displayName: "FloatingButton__Layout",
  componentId: "sc-6zb2bs-0"
})(["height:0;pointer-events:none;position:sticky;z-index:", ";bottom:50%;width:100%;"], zIndex.floatingAction);
const MarbleLayout = styled.div.withConfig({
  displayName: "FloatingButton__MarbleLayout",
  componentId: "sc-6zb2bs-1"
})(["float:right;"]);
const StyledMarble = styled(Marble).withConfig({
  displayName: "FloatingButton__StyledMarble",
  componentId: "sc-6zb2bs-2"
})(["background:transparent;"]);
const pulse = keyframes(["0%,100%{opacity:1;}50%{opacity:0.5;}"]);
const StyledButton = styled(Button).withConfig({
  displayName: "FloatingButton__StyledButton",
  componentId: "sc-6zb2bs-3"
})(["pointer-events:all;padding:0;height:100%;width:100%;border-radius:50%;", ";animation:", " 2s cubic-bezier(0.4,0,0.6,1) infinite;", "{&:hover{", ";animation:none;}}"], Shadows.applySingle(), pulse, Device.mouse, Shadows.applyDouble(8));